import { createTranslations } from '@npco/common-utils-translations'

export const corporateCardStartupTranslations = createTranslations({
  title: 'Your finance team will love Zeller Corporate Cards.',
  description:
    'Zeller Corporate Cards enable you to manage team expenses, track spending, and reconcile accounts, without hours of paperwork.',
  point1: 'Set recurring budgets and transaction limits.',
  point2: 'Attach notes, receipts, and invoices to expenses.',
  point3: 'Manage project or team-level budgets.',
  point4: 'Track every expense from Zeller App or Zeller Dashboard.',
  description2:
    'Invite your team members to become Users in your Zeller Account. Once they’re verified, you can create their Zeller Corporate Card from Cards in the main menu.',
  primaryButtonLabel: 'Create Card',
})
